<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
		<v-col class="pa-0">

            <v-card class="flex pa-0 background-2 round-card">
			    <v-card-title class="pa-3">
    				<p class="pl-3">Lista di prelievo</p>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-row class="pa-0 pr-4">
                        <v-text-field class=" font-weight-regular"
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            background-color="background-2"
                            outlined
                            dense               
                        ></v-text-field>                    
                    </v-row>

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">							
                            <v-btn @click="$eventBusUtility.exportCSV(headers, items, 'Lista di Prelievo')" v-on="on" icon>
                                <v-icon>get_app</v-icon>
                            </v-btn>
                        </template>
                        <span>Download</span>
                    </v-tooltip>                    
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">                        
                            <v-btn v-on="on" @click="printPickList()" icon>
                                <v-icon>print</v-icon>
                            </v-btn>
                        </template>
                        <span>Download PDF</span>
                    </v-tooltip>

                    <columns-selector v-if="headers.length"
                        :columns.sync="headers"
                        model-def="saleorderspicklist"
                    ></columns-selector>
			    </v-card-title>
                <v-divider></v-divider>

                <v-alert
                    text
                    dense
                    type="info"
                    class="ma-4 mb-0"
                    icon="mdi-information-outline">
                    <span class="body-2">
                        Questa schermata consente di visualizzare e gestire i prodotti presenti negli ordini di vendita
                        che devono essere evasi e consegnati ai clienti. Puoi filtrare i prodotti, selezionarli
                        e generare automaticamente gli ordini di acquisto ai fornitori.
                    </span>
                </v-alert>

                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                    <fields-generator
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>

                    <!-- <v-row class="mx-0 pt-0">
                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Dividi per cliente" v-model="model['group_by_companies']" value="companies"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Dividi per destinazione" v-model="model['group_by_destinations']" value="destinations"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Dividi per ordine" v-model="model['group_by_saleorder']" value="saleorder"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Dividi per data di consegna" v-model="model['group_by_delivery_date']" value="delivery_date"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Stampa Importi" v-model="model['print_import']" value="print_import"></v-switch>
                        </v-col>
                        
                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Espandi Kit" v-model="model['expand_kit']" value="expand_kit"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="12" v-if="$store.getters.checkModulePermissions('banci')">
                            <duplicates-select
                                label="Colori"
                                :items="colors"
                                v-model="model['colors']"
                            ></duplicates-select>
                        </v-col>
                    </v-row> -->
			        <v-divider></v-divider>

                    <v-data-table
                        :items="items"
                        :headers="showHeaders"
                        :loading="loading"
			            v-model="selected"
                        :search="search"
                        show-select
                        hide-default-footer
                        fixed-header
                        :page.sync="page"
                        :itemsPerPage.sync="itemsPerPage"
                        class="background-2 enhanced-table"
			            :mobile-breakpoint="0"
                        ref="picklist"
                        :footer-props="{
                            'items-per-page-options': [10, 25, 50, 100, { text: 'Tutti', value: -1 }],
                            showFirstLastPage: true
                        }">

                        <template v-slot:header.data-table-select="{ on, props }">
                            <v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
                        </template>

                        <!-- Empty state - no data -->
                        <template v-slot:no-data>
                            <v-container v-if="!loading && !search" class="text-center py-8">
                                <v-icon size="64" color="grey lighten-2">inventory_2</v-icon>
                                <h3 class="mt-4 grey--text">Nessun prodotto trovato</h3>
                                <p class="grey--text text--lighten-1">Modifica i filtri per visualizzare i prodotti da prelevare</p>
                            </v-container>
                            <v-container v-else-if="!loading" class="text-center py-8">
                                <v-icon size="64" color="grey lighten-2">search_off</v-icon>
                                <h3 class="mt-4 grey--text">Nessun risultato trovato</h3>
                                <p class="grey--text text--lighten-1">Prova a modificare i criteri di ricerca</p>
                            </v-container>
                        </template>

                        <!-- Empty state - no search results -->
                        <template v-slot:no-results>
                            <v-container v-if="!loading" class="text-center py-8">
                                <v-icon size="64" color="grey lighten-2">search_off</v-icon>
                                <h3 class="mt-4 grey--text">Nessun risultato trovato</h3>
                                <p class="grey--text text--lighten-1">Prova a modificare i criteri di ricerca</p>
                            </v-container>
                        </template>

                        <template v-slot:item="{item, select, isSelected, isExpanded, headers, index}">
                            <tr class="cursor-pointer">
                                <template v-for="(header, h) in headers">
                                    <td :key="h" v-if="header.value == 'data-table-select'">
                                        <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                                    </td>                                
                                    <td v-else-if="header.type === 'currency'" :key="h">
                                        {{ item[header.value] | currency(2) }}
                                    </td>
                                    <td v-else-if="header.type == 'date'" :key="h">
                                        {{ item[header.value] | date }}
                                    </td>
                                    <td v-else-if="typeof header.text_value !== 'undefined'" :key="h">
                                        {{ item[header.text_value] }}
                                    </td>
                                    <td v-else-if="header.type == 'chips'" :class="'text-xs-'+header.align" :key="h">
                                        <v-chip v-for="(chip, c) in JSON.parse(item[header.value])" small :key="c">{{ chip }}</v-chip>
                                    </td>

                                    <td v-else-if="header.type == 'purchase_price' && $store.getters.checkModelPermissions('purchaseorder')" style="min-width: 130px; max-width: 150px;" :key="h">
                                        <v-text-field
                                            :disabled="!isSelected"
                                            label="Prezzo"
                                            v-model="item['purchase_price']"
                                            type="number"
                                            step="0.01"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </td>

                                    <td v-else-if="header.type == 'suppliers' && $store.getters.checkModelPermissions('purchaseorder')" style="min-width: 200px; max-width: 300px;" :class="'text-xs-'+header.align" :key="h">
                                        <v-autocomplete
                                            autocomplete="no"
                                            :disabled="!isSelected"
                                            label="Fornitore"
                                            :items="item.suppliers"
                                            v-model="item['supplier_id']"
                                            :menu-props="{maxHeight:'200'}"
                                            :return-object="false"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            v-validate="!isSelected ? '' : 'required'"
                                            :error-messages="errors.collect('Fornitore'+item.id)"
                                            data-vv-as="Fornitore"
                                            :data-vv-name="'Fornitore'+item.id"
                                            @change="onSupplierChange(item, $event)"
                                            >
                                            <template v-slot:item="data">
                                                <template>
                                                    <v-list-item-avatar
                                                        size="32px"
                                                        style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                                        class="primary mr-4">
                                                        <v-icon class="fs18i" color="white">store_mall_directory</v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <span>{{ data.item.subtitle }}</span>
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </template>
                                            </template>                                            
                                        </v-autocomplete>
                                    </td>
                                    <td v-else-if="header.type == 'quantity' && $store.getters.checkModelPermissions('purchaseorder')" style="min-width: 130px; max-width: 150px;" :class="'text-xs-'+header.align" :key="h">
                                        <v-text-field
                                            :disabled="!isSelected"
                                            label="Quantità"
                                            v-model="item['quantity_to_ordered']"
                                            type="number"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            v-validate="'required'"
                                            data-vv-as="Quantità"
                                            :data-vv-name="'Quantità'+item.id"
                                            :error-messages="errors.collect('Quantità'+item.id)"
                                            >
                                        </v-text-field>
                                    </td>
                                    <td v-else :key="h">
                                        {{ header.type}}
                                        {{ item[header.value] }}
                                    </td>
                                </template>
                            </tr>
                        </template>


                        <template v-slot:footer="{ props }">
                            <v-divider></v-divider>
                            <v-spacer></v-spacer>
                            <div class="text-right background pa-4 py-0">
                                <div class="text-right d-inline-flex">
                                    <div class="d-inline-flex">
                                        <div class="caption align-self-center mr-6">Righe per pagina:</div>
                                        <v-select
                                            class="mr-6 align-self-center"
                                            style="width: 60px; font-size: 12px !important"
                                            :items="[{'text': '10', 'value': 10}, {'text': '25', 'value': 25}, {'text': '50', 'value': 50}, {'text': 'Tutti', 'value': -1}]"
                                            :value="itemsPerPage"
                                            type="number"
                                            @input="itemsPerPage = parseInt($event)"
                                        ></v-select>                                    
                                    </div>
                                    <div class="text-right align-self-center caption pr-4">
                                        <div class="warning--text text-center"><span>{{ selected.length }}</span> Selezionati</div>
                                        Da {{ props.pagination.pageStart + 1 }} a {{ props.pagination.pageStop }} di {{ items.length }}
                                    </div>
                                    <v-btn fab small class="mr-4 ma-auto elevation-0" :text="page == 1" :disabled="page == 1" color="background-2" @click="prevPage()">
                                        <v-icon :disabled="page == 1">chevron_left</v-icon>
                                    </v-btn>
                                    <v-btn fab small class="ml-4 ma-auto elevation-0" :text="page == maxPage" :disabled="page == maxPage" color="background-2" @click="nextPage()">
                                        <v-icon>chevron_right</v-icon>
                                    </v-btn>
                                </div>
                            </div>

                        </template> 
                    </v-data-table>
                </v-container>
                <v-speed-dial
                    v-model="fab"
                    fixed
                    bottom
                    right
                    direction="left"
                    transition="scale-transition">
                    <template v-slot:activator>
                        <v-btn
                            color="primary"
                            dark
                            fab
                            v-model="fab">
                            <v-icon v-if="fab">close</v-icon>
                            <v-icon v-else>local_offer</v-icon>
                        </v-btn>      
                    </template>              
                    <v-tooltip top>
                        <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                                v-on="{ ...tooltip }"
                                fab
                                dark
                                small
                                color="warning"
                                :depressed="selected.length == 0"
                                :disabled="selected.length == 0"
                                @click.native.stop="openGeneratePurchaseorder()">
                                <v-icon>assignment</v-icon>
                            </v-btn>
                        </template>
                        <span>Genera Ordini di Acquisto</span>
                    </v-tooltip>
                </v-speed-dial>        
                
                <v-dialog v-model="confirmModel" max-width="600" persistent ref="purchaseordersDialog">
                    <v-card class="background-2 round-card">
                        <v-card-title primary-title class="subtitle-1 background-2">Vuoi generare gli ordini di acquisto per i seguenti prodotti selezionati?</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="pt-4 body-2">Sarà generato un ordine di acquisto per ogni fornitore scelto</v-card-text>

                        <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-4">
                            <fields-generator
                                :fieldsset.sync="info"
                                :model.sync="purchaseorders"
                                ref="fieldsgenerator"
                            ></fields-generator>
                        </v-container>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click.native.stop="confirmModel = false" >Annula</v-btn>
                            <v-btn text color="info" @click.native.stop="generatePurchaseOrder()">Conferma</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
        </v-col>       
    </v-row>
</template>

<script>

    import ColumnsSelector from '@/components/common/ColumnsSelector'

    export default {
        name: "pick-list",
        components: { ColumnsSelector },
        data() {
            return {
			    search: '',
				items: [],
				loading: false,
                filtered: false,
                headers: [],
                fieldsset: {},
                model: {},
                purchaseorders: {},
                info: {},
                totalItems: 0,
                colors: [],
				selected: [],
                fab: false,
                confirmModel: false,
                page: 1,
                itemsPerPage: 10,
                allSuppliers: [],
                allowAllSuppliers: false,
            }
        },

        computed: {

            maxPage() {
                if (this.itemsPerPage === -1) return 1
                return Math.max(1, Math.ceil(this.items.length / this.itemsPerPage))
            },

            showHeaders() {
                return this.headers.filter(item => !!item.hide)
            }

        },

        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
                immediate: true
            }
        },

        methods: {

            prevPage() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    this.page = this.page - 1
                }).catch(() => {})               
            },

            nextPage() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    this.page = this.page + 1
                }).catch(() => {})             
            },

            getData() {
                this.loading = 'warning'
                this.axios.post('saleorderspicklist', this.model).then(response => {
                    this.items = response.data.data
                    this.selected = []
                    this.totalItems = response.data.data.length
                    this.totals = response.data.data.totals
                    this.loading = false

                }, response => {
                    // error callback
                })
            },

            printPickList() {
                this.$eventBusUtility.openFileInline(this.$store, '/saleorderspicklist-print', 'Lista prelievo', 'POST', this.model)
            },

            selectChange(event) {
                if(this.$store.getters.checkModulePermissions('banci') && event && event.key == 'product_id') {
                    this.axios.get('products/' + this.model.product_id).then(response => {
                        this.colors = response.data.model.colors
                    }, response => {
                        // error callback
                    })
                } else {
                    this.colors = []
                    this.model.colors = []
                }
            },

            onSupplierChange(item, supplierId) {
                if (supplierId && item.suppliers) {
                    const selectedSupplier = item.suppliers.find(s => s.value === supplierId)
                    if (selectedSupplier) {
                        this.$set(item, 'purchase_price', selectedSupplier.purchase_price || 0)
                    }
                }
            },

            openGeneratePurchaseorder() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    this.axios.get('saleorderspicklist-generate-purchaseorders-info').then(response => {

                        this.info = response.data.fields
                        this.confirmModel = true
                    }, response => {
                        // error callback
                    })
                }).catch(() => {})                   
            },
            
            generatePurchaseOrder() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false;
                    }
                    this.purchaseorders.orders = this.selected
                    this.axios.post('saleorderspicklist-generate-purchaseorders', this.purchaseorders).then(response => {
                        // get body data

                        this.$router.push({name: 'purchaseorders-index'})

                    }, response => {
                        // error callback
                    })
                }).catch(() => {

                })                    
            }
        },
        
        created() {
            this.axios.get('saleorderspicklist-info').then(response => {
                // get body data
                this.fieldsset = response.data.fields
                this.headers = response.data.info.fieldDefs

                this.$store.commit('endProgress')

            }, response => {
                // error callback
            })
        },
    }
</script>

<style scoped>
    th.sortable {
        white-space: nowrap;
    }

    .v-data-table__wrapper {
        overflow-x: auto;
        overflow-y: auto;
        max-height: 66vh;
    }

    @media screen and (max-width: 600px) {
        .v-data-table__wrapper {
            max-height: 54vh;
        }
    }

    .v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
        top: -1px !important;
    }

    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
    .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
    .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
    .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
        padding: 0 10px;
    }

    .v-data-table__progress > .column {
        height: 0px !important;
        padding: 0px !important;
        margin: 0px !important;
    }
</style>
